
import { Component, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';
import { DataService as CoreDataService, QueryColumn } from '@barthauer/abc/core/data';
import { Observable, Subscription } from 'rxjs';
import { DataService, ObjectKeys } from '../../services/data.service';
import { FavoritesComponent } from '../shared/favorite/favorites.component';
import { ItemClickEvent } from 'devextreme/ui/list';
import { Audit, BibCategory, BibMeasure, BibQuestion, BibResponse, Library } from '@barthauer/custom/xmt-models';
@Component({
  selector: 'favorite-list',
  templateUrl: './favorite-list.component.html',
  styleUrls: ['./favorite-list.component.scss'],
  imports: [FavoritesComponent],
})
export class FavoriteListComponent {
  @Output() closebtn: EventEmitter<any> = new EventEmitter();
  public ObjectTypeNames = ObjectTypeNames;

  private subscriptions: Subscription[] = [];

  constructor(
    public readonly dataService: DataService,
    private readonly router: Router,
    private readonly coreDataService: CoreDataService
  ) {}

  public itemClicked(event: ItemClickEvent): void {
    switch (event.itemData.ObjectType) {
      case ObjectTypeNames.Company: {
        this.changeFavouriteStyle(['container'], '1', 'auto');
        this.dataService.prepareCompanyData(event.itemData.ParentId, event.itemData.DisplayText);
        this.dataService.setFavoriteData(event.itemData.ParentId, event.itemData.ParentId);
        localStorage.setItem('companyId', event.itemData.ParentId);
        localStorage.setItem('companyName', event.itemData.DisplayText);
        this.router.navigateByUrl('dashboard');
        this.closeFavorites();
        break;
      }
      case ObjectTypeNames.AudAudit: {
        this.subscriptions.push(
          this.getAudit(event.itemData.ParentId).subscribe((data) => {
            if (Array.isArray(data) && data.length > 0) {
              this.dataService.setFavoriteData('audit', data[0].toString());
              localStorage.setItem('libraryId', data[0]['LibraryId']);
              localStorage.setItem('auditDesignation', data[0].Designation);
              localStorage.setItem('auditCompanyName', data[0].Company.toString());
              localStorage.setItem('auditCompanyId', data[0]['CompanyId']);
              this.router.navigate(['evaluation', event.itemData.ParentId]);
            }
          })
        );
        this.changeFavouriteStyle(['container'], '1', 'auto');
        this.closeFavorites();
        break;
      }
      case ObjectTypeNames.AudBibCategory:
        this.subscriptions.push(
          this.getName(event.itemData.ParentId, ObjectKeys.BIBCATEGORY).subscribe((data) => {
            this.dataService.setFavoriteData('category', data[0].Designation);
            localStorage.setItem('categoryName', data[0].Designation);
            this.router.navigateByUrl('categories');
            this.closeFavorites();
          })
        );
        break;
      case ObjectTypeNames.AudLibrary:
        this.subscriptions.push(
          this.getName(event.itemData.ParentId, ObjectKeys.LIBRARY).subscribe((data) => {
            this.dataService.setFavoriteData('library', data[0].Designation);
            localStorage.setItem('libraryName', data[0].Designation);
            this.router.navigateByUrl('libraries');
            this.closeFavorites();
          })
        );
        break;
      case ObjectTypeNames.AudBibQuestion:
        this.subscriptions.push(
          this.getName(event.itemData.ParentId, ObjectKeys.BIBQUESTION).subscribe((data) => {
            this.dataService.setFavoriteData('question', data[0].Designation);
            localStorage.setItem('questionName', data[0].Designation);
            this.router.navigateByUrl('questions');
            this.closeFavorites();
          })
        );
        break;
      case ObjectTypeNames.AudBibResponse:
        this.subscriptions.push(
          this.getName(event.itemData.ParentId, ObjectKeys.BIBRESPONSE).subscribe((data) => {
            this.dataService.setFavoriteData('response', data[0].Designation);
            localStorage.setItem('responseName', data[0].Designation);
            this.router.navigateByUrl('responses');
            this.closeFavorites();
          })
        );
        break;
      case ObjectTypeNames.AudBibMeasure:
        this.subscriptions.push(
          this.getMeasureName(event.itemData.ParentId, ObjectKeys.BIBMEAUSRE).subscribe((data) => {
            this.dataService.setFavoriteData('measure', data[0].Title);

            localStorage.setItem('measureName', data[0].Title);
            this.router.navigateByUrl('measures');
            this.closeFavorites();
          })
        );
        break;
      default: {
        this.router.navigateByUrl('');
        this.closeFavorites();
      }
    }
  }

  public getAudit(id: string): Observable<Audit[]> {
    const queryColumns: Array<QueryColumn> = [
      this.coreDataService.createQueryColumn('Id', 'Id'),
      this.coreDataService.createQueryColumn('Designation', 'Designation'),
      this.coreDataService.createQueryColumn('IdRefLibrary', 'LibraryId'),
      this.coreDataService.createQueryColumn('ref:ParentId', 'Company'),
      this.coreDataService.createQueryColumn('ParentId', 'CompanyId'),
    ];
    const oPath = `Id='${id}'`;
    return this.dataService.readObjects(ObjectKeys.AUDIT, queryColumns, oPath);
  }

  public getName(
    id: string,
    objectKey: string
  ): Observable<
    | Pick<BibCategory, 'Designation'>[]
    | Pick<Library, 'Designation'>[]
    | Pick<BibQuestion, 'Designation'>[]
    | Pick<BibResponse, 'Designation'>[]
  > {
    const queryColumns: Array<QueryColumn> = [this.coreDataService.createQueryColumn('Designation', 'Designation')];
    const oPath = `Id='${id}'`;
    return this.dataService.readObjects(objectKey, queryColumns, oPath);
  }
  public getMeasureName(id: string, objectKey: string): Observable<Pick<BibMeasure, 'Title'>[]> {
    const queryColumns: Array<QueryColumn> = [this.coreDataService.createQueryColumn('Title', 'Title')];
    const oPath = `Id='${id}'`;
    return this.dataService.readObjects(objectKey, queryColumns, oPath);
  }

  public openFavorites(): void {
    document.getElementById('favouritesContainer').style.width = '400px';
    this.changeFavouriteStyle(['container'], '0.2', 'auto');
  }

  public closeFavorites(): void {
    document.getElementById('closeFavoritebtn').style.visibility = 'hidden';
    document.getElementById('favouritesContainer').style.width = '0';
    this.changeFavouriteStyle(['container'], '1', 'auto');
    this.closebtn.emit();
  }

  public changeFavouriteStyle(listIds: Array<string>, opacity: string, pointerEvents: string): void {
    listIds.forEach((ids) => {
      document.getElementById(ids).style.visibility = 'true';
      document.getElementById(ids).style.opacity = opacity;
      document.getElementById(ids).style.pointerEvents = pointerEvents;
    });
  }
}

export enum ObjectTypeNames {
  Company = 111000100,
  AudAudit = 330001159,
  AudBibCategory = 330001121,
  AudLibrary = 330001125,
  AudBibQuestion = 330001123,
  AudBibResponse = 330001124,
  AudBibMeasure = 330001122,
}
